import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { Stack, StackChild } from '@tanium/react-stack';
import { WorkbenchLocaleProvider } from '@tanium/react-locale-context';
import { AppHeader } from '../AppHeader/AppHeader';
import { AppContent } from '../AppContent/AppContent';
import { AppHeaderStyle } from '../AppHeader/AppHeaderStyle';
import { SideNav } from '../SideNav/SideNav';
import { TaniumInstancesProvider } from '../../hooks/useTaniumInstances';

const headerHeight = AppHeaderStyle.borderHeight + AppHeaderStyle.containerHeight;

const Body = styled(Box)(
  css({
    marginTop: `${headerHeight}px`,
    height: `calc(100vh - ${headerHeight}px)`,
    overflowX: 'hidden',
    overflowY: 'auto',
  })
);

export const Shell: React.VFC = () => {
  return (
    <WorkbenchLocaleProvider workbenchLocale={'en-US'}>
      <TaniumInstancesProvider>
        <AppHeader />
        <Body>
          <Stack height="100%">
            <SideNav />
            <StackChild grow={1} overflowX="hidden" overflowY="auto">
              <AppContent />
            </StackChild>
          </Stack>
        </Body>
      </TaniumInstancesProvider>
    </WorkbenchLocaleProvider>
  );
};
